module.exports = __webpack_public_path__ + "static/assets/73bdfee64cdf97022200bc10602ab9fd.svg";